export default "__VITE_ASSET__37d5e8e8__"